import { Button, Stack, Text, Title } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { reloadApp } from '@/helpers/appVersion';
import styles from './StaleVersionFallback.module.sass';

export const StaleVersionFallback = () => {
  const { t } = useTranslation('global');

  const handleReloadClick = (): void => {
    reloadApp();
  };

  return (
    <main className={styles.root}>
      <Stack align="center" gap="md" className={styles.content}>
        <Title order={2}>{t('appVersion.updateTitle')}</Title>
        <Text size="sm" ta="center">
          {t('appVersion.updateMessage')}
        </Text>
        <Button type="button" leftSection={<IconRefresh size={16} />} onClick={handleReloadClick}>
          {t('appVersion.reloadButton')}
        </Button>
      </Stack>
    </main>
  );
};
